
import ScrollSpy from 'bootstrap/js/dist/scrollspy.js';


const scrollSpy = new ScrollSpy(document.body, {
  // target: '#navbar-example'
})